import React from 'react';
import { CFooter } from '@coreui/react';

const TheFooter = () => (
  <CFooter fixed={false}>
    <div>
      <span className="ml-1">
        Copyright ©
        {' '}
        {new Date().getFullYear()}
        {' '}
        Motogwarancja
      </span>
    </div>
    <div className="mfs-auto">
      <span className="mr-1">Powered by</span>
      <a href="https://appstract.software" target="_blank" rel="noopener noreferrer">appstract.software</a>
    </div>
  </CFooter>
);

export default React.memo(TheFooter);
